/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ColorWheel from './ColorWheel';
import ColorGrid from './ColorGrid';
import Favorites from './Favorites';
import StringResources from 'nls/StringResources';
import {
	Select,
	Tabs,
	TabPanel,
	Dialog,
	Link,
	FlexLayout,
	Separator
} from 'ca-ui-toolkit';
import '../../stylesheets/all.scss';


const MAX_FAVORITES = 12;

// CustomPalette class
export default class CustomColorDialog extends Component {

	static propTypes = {
		isDialogOpen: PropTypes.bool,
		glassContext: PropTypes.object,
		paletteService: PropTypes.object,
		onChange: PropTypes.func,
		onCloseDialog: PropTypes.func
	}
	static defaultProps = {
		isDialogOpen: false
	};

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed, the selectedTab for the tab panel and the selected item in the select drop down list
	constructor(props) {
		super(props);

		this.favoritesView = null;
		this.state = {
			currentColor: null,
			isDialogOpen: props.isDialogOpen || false,
			selectedTab: 'idColorGrid',
			selectedColorType: 'RGB'
		};
	}

	componentDidMount() {
		const paletteServicePromise = this.props.paletteService? Promise.resolve(this.props.paletteService) : this.props.glassContext.getSvc('.Palette');
		paletteServicePromise.then((service) => {
			service.getFavoriteColors().then((cmFavoriteColors) => {
				this.favoritesView.setState({
					favoriteColors: cmFavoriteColors
				});
			});
		});
	}

	updateSelectedColor(color){
		this.setState({
			currentColor: color
		});
	}

	setColor(color) {
		this.updateSelectedColor(color);
		if (this.favoritesView.isFavoriteSelected()) {
			this.favoritesView.updateSelectedColor(color);
			this.favoritesView.deselectCurrentFavorite();
		}
	}

	addFavorite() {
		if(this.state.currentColor && this.favoritesView.state.favoriteColors.length < MAX_FAVORITES){
			let colors = this.favoritesView.state.favoriteColors;
			colors.push(this.state.currentColor);
			this.favoritesView.setState({
				favoriteColors: colors
			});
		}
	}

	applyPaletteColor = () => {
		const paletteServicePromise = this.props.paletteService? Promise.resolve(this.props.paletteService) : this.props.glassContext.getSvc('.Palette');
		paletteServicePromise.then((service) => {
			service.setFavoriteColors(this.favoritesView.getFavoriteColors()).then(() => {
				this.props.onChange(this.state.currentColor);
				this.closeDialog();
			}, (error) => {
				console.log(error);
			});
		});
	}

	closeDialog = () => {
		this.setState({ isDialogOpen: false });
		if(this.props.onCloseDialog){
			this.props.onCloseDialog();
		}
	}

	openDialog = () => {
		this.setState({ isDialogOpen: true });
	}

	render() {
		const myList = [
			{ value: 'RGB', label: StringResources.get('modelRGB') },
			// { value: 'CMYK', label: StringResources.get('modelCMYK') },
			{ value: 'HSB', label: StringResources.get('modelHSB') }
		];
		return (
			(this.state.isDialogOpen &&
			(
				<div>
					<Dialog width='620px' onClose={this.closeDialog} className="customColorDialog">
						<Dialog.Header>{StringResources.get('colorPicker')}</Dialog.Header>
						<Dialog.Body>
							<div>
								<Tabs selected={this.state.selectedTab} onChange={tabId => this.setState({ selectedTab: tabId })}>
									<TabPanel keepTabContent={true} id={'idColorGrid'} label={StringResources.get('grid')}>
										<div style={{ height: '260px', 'paddingTop': '15px' }}>
											<table>
												<tbody>
													<tr>
														<td align="center" style={{ width: '50%' }}>
															<ColorGrid
																id={'idColorGridComponent'}
																onColorChange={this.setColor.bind(this)}
															/>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel keepTabContent={true} id={'idColorWheel'} label={StringResources.get('wheel')}>
										<div style={{ 'height': '300px', 'paddingTop': '15px' }}>
											<table>
												<tbody>
													<tr>
														<td align="right" style={{ width: '90%' }}>
															<div style={{ marginBottom: '8px' }}>
																<Select
																	selected={this.state.selectedColorType}
																	customWidth='250px'
																	options={myList}
																	onChange={value => this.setState({ selectedColorType: value })}
																/>
															</div>
															<ColorWheel
																onColorChange={this.setColor.bind(this)}
																color={this.state.currentColor}
																selectedColorType={this.state.selectedColorType}
															/>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</TabPanel>
								</Tabs>
								<FlexLayout direction='column'>
									<FlexLayout justifyContent='flex-end'>
										<Link style={{ zIndex: 3000, 'margin-right': '40px' }} onClick={this.addFavorite.bind(this)}>{StringResources.get('setAsFavorite')}</Link>
									</FlexLayout>
									<Separator orientation='horizontal' style={{ margin: '24px 0px' }}></Separator>
									<Favorites
										favoriteColors={[]}
										updateColor={this.updateSelectedColor.bind(this)}
										ref={(element) => { this.favoritesView = element; } }
										numberOfFavorites={MAX_FAVORITES}>
									</Favorites>
								</FlexLayout>
							</div>
						</Dialog.Body>
						<Dialog.Footer>
							<Dialog.Button label={StringResources.get('applyDialog')} onClick={this.applyPaletteColor} disabled={!this.state.currentColor}/>
							<Dialog.Button label={StringResources.get('cancelDialog')} onClick={this.closeDialog} />
						</Dialog.Footer>
					</Dialog>
				</div>
			)) || null
		);
	}
}

CustomColorDialog.defaultProps = {
	name: 'CustomColorDialog'
};



// WEBPACK FOOTER //
// ./src/js/dialog/CustomColorDialog.js